import { render, staticRenderFns } from "./AddScript.vue?vue&type=template&id=758a4ff1"
import script from "./AddScript.vue?vue&type=script&lang=js"
export * from "./AddScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports